import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-90a94652"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "table-page-search-submitButtons",
  style: { float: 'right', overflow: 'hidden' } || {}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 6 }
const _hoisted_13 = ["onClick"]

import { ref, onMounted, reactive } from "vue";
import { useRoute } from "vue-router";
import api from "@/api/index";
import { downloadFileByPos, getDic } from "@/api/pos";
import { FormInstance, message } from "ant-design-vue";
import { getOperationLog } from "@/api/operation";
interface FormState {
  state: string | undefined;
  liabilityType: string | undefined;
  operationDateFrom: string | undefined;
  operationDateTo: string | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OperationLog',
  setup(__props) {

const dataSource = ref<Array<any>>([]);
const loading = ref<boolean>(false);
const route = useRoute();
const checkPosDetailInfo = ref(null);
const currentPage = ref(1);
const pageSizeConfig = ref(10);
const totalData = ref(0);
const operationDateFrom = ref<string>("");
const operationDateTo = ref<string>("");
const operationCodeDicList = ref<Array<any>>([]);
const formRef = ref<FormInstance>();
const formState = reactive<FormState>({
  state: undefined,
  liabilityType: undefined,
  operationDateFrom: undefined,
  operationDateTo: undefined,
});
const columns = ref<Array<any>>([
  {
    title: "时间",
    dataIndex: "operationTime",
    key: "operationTime",
  },
  {
    title: "账号",
    dataIndex: "userName",
    key: "userName",
  },
  {
    title: "操作类型",
    dataIndex: "operationName",
    key: "operationName",
  },
  {
    title: "详细内容",
    dataIndex: "operationDesc",
    key: "operationDesc",
  },
]);

onMounted(() => {
  getTableData();
  getDic({}).then((res) => {
    operationCodeDicList.value = res.data.operationCodeDicList;
  }).catch;
});

const onChangePage = (pageNum: number, pageSize: number) => {
  let data = {
    pageNum: pageNum,
    pageSize: pageSize,
  };
  currentPage.value = pageNum;
  pageSizeConfig.value = pageSize;
  getTableData(data);
};
const getTableData = async (paramater: any = {}) => {
  let res: any = await getOperationLog(paramater);
  if (res.code == 200) {
    dataSource.value = res.data.dataList;
    totalData.value = res.data.total;
  }
};
const onChangeRangePicker = (date: any, dateString: any) => {
  operationDateFrom.value = dateString[0];
  operationDateTo.value = dateString[1];
};
const getDownloadUrl = async (record: any) => {
  let paramater = {
    id: record.attachmentId,
    duration: 600,
  };
  let res: any = await downloadFileByPos(paramater);
  if (res.code == 200) {
    let a = document.createElement("a");
    a.href = res.data;
    a.click();
  } else {
    message.error(res.msg);
  }
};
const Reset = () => {
  if (formRef.value) formRef.value.resetFields();
  operationDateFrom.value = "";
  operationDateTo.value = "";
};
const handleSearch = (values: FormState) => {
  values.operationDateFrom = operationDateFrom.value;
  values.operationDateTo = operationDateTo.value;
  getTableData(values);
};
const handleFinishFailed = (errors: any) => {
  console.log(errors);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { style: {"max-width":"1440px","margin":"0 auto","margin-top":"32px"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_a_form, {
          ref_key: "formRef",
          ref: formRef,
          model: formState,
          onFinish: handleSearch,
          onFinishFailed: handleFinishFailed,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xxl: 6,
                  xl: 8,
                  lg: 8,
                  sm: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "操作类型：",
                      name: "operationCode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          value: formState.operationCode,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.operationCode) = $event)),
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operationCodeDicList.value, (foo) => {
                              return (_openBlock(), _createBlock(_component_a_select_option, {
                                key: foo.code
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(foo.name), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xxl: 6,
                  xl: 8,
                  lg: 8,
                  sm: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "操作时间段：",
                      name: "operationDateFrom"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_range_picker, {
                          value: formState.operationDateFrom,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.operationDateFrom) = $event)),
                          placeholder: ['开始日期', '结束日期'],
                          onChange: onChangeRangePicker
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xxl: 6,
                  xl: 8,
                  lg: 8,
                  sm: 24
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, [
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"20px","width":"90px"},
                        type: "primary",
                        "html-type": "submit"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("查询")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_button, {
                        style: {"margin-left":"16px","width":"90px"},
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (Reset()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("重置")
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createVNode(_component_a_table, {
        dataSource: dataSource.value,
        columns: columns.value,
        pagination: {
        current: currentPage.value,
        onChange: onChangePage,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total: totalData.value,
        pageSize: pageSizeConfig.value,
      },
        loading: loading.value
      }, {
        bodyCell: _withCtx(({ column, text, record }) => [
          (column.key === 'operationDesc')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (record.operationCode == 'EXPORT_POS')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      _createTextVNode(" 导出了 "),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (getDownloadUrl(record)),
                        style: {"color":"#42b983"}
                      }, _toDisplayString(record.attachmentName), 9, _hoisted_4)
                    ]))
                  : _createCommentVNode("", true),
                (record.operationCode == 'EXPORT_CLAIM')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                      _createTextVNode(" 导出了 "),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (getDownloadUrl(record)),
                        style: {"color":"#42b983"}
                      }, _toDisplayString(record.attachmentName), 9, _hoisted_6)
                    ]))
                  : _createCommentVNode("", true),
                (record.operationCode == 'POS_REDUCE')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "对" + _toDisplayString(record.targetUserNames) + "进行单人退保操作", 1))
                  : _createCommentVNode("", true),
                (record.operationCode == 'POS_ADD')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "对" + _toDisplayString(record.targetUserNames) + "进行单人投保操作", 1))
                  : _createCommentVNode("", true),
                (record.operationCode == 'CHANGE_POS_LEVEL')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "对" + _toDisplayString(record.targetUserNames) + "进行了层级变更", 1))
                  : _createCommentVNode("", true),
                (record.operationCode == 'UPLOAD_POS_BATCH_ADD')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                      _createTextVNode(" 上传了批量投保文件 "),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (getDownloadUrl(record)),
                        style: {"color":"#42b983"}
                      }, _toDisplayString(record.attachmentName), 9, _hoisted_11)
                    ]))
                  : _createCommentVNode("", true),
                (record.operationCode == 'UPLOAD_POS_BATCH_REDUCE')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(" 上传了批量退保文件 "),
                      _createElementVNode("a", {
                        onClick: ($event: any) => (getDownloadUrl(record)),
                        style: {"color":"#42b983"}
                      }, _toDisplayString(record.attachmentName), 9, _hoisted_13)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["dataSource", "columns", "pagination", "loading"])
    ]),
    _: 1
  }))
}
}

})